import { render, staticRenderFns } from "./DiscountCreateAndUpdateFormItems.vue?vue&type=template&id=081343e9&"
import script from "./DiscountCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./DiscountCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081343e9')) {
      api.createRecord('081343e9', component.options)
    } else {
      api.reload('081343e9', component.options)
    }
    module.hot.accept("./DiscountCreateAndUpdateFormItems.vue?vue&type=template&id=081343e9&", function () {
      api.rerender('081343e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiscountCreateAndUpdateFormItems.vue"
export default component.exports